export default __webpack_public_path__ + "static/media/default_news_announcements.b0bfdd80.png";